<div *ngIf="result" class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">A(s) boleta(s) contém os erros abaixo:</h5>
  </div>
  <div class="modal-body">
    <div class="table-container">
      <cota-error *ngIf="ticketTypesId === 1" [result]="result"></cota-error>
      <rf-privado-error
        *ngIf="ticketTypesId === 2"
        [result]="result"
      ></rf-privado-error>
      <rf-publico-error
        *ngIf="ticketTypesId === 3"
        [result]="result"
      ></rf-publico-error>
      <compromissada-error
        *ngIf="ticketTypesId === 4"
        [result]="result"
      ></compromissada-error>
      <futuros-error
        *ngIf="ticketTypesId === 5"
        [result]="result"
      ></futuros-error>
      <swap-cetip-error
        *ngIf="ticketTypesId === 6"
        [result]="result"
      ></swap-cetip-error>
      <margem-error *ngIf="ticketTypesId === 7" [result]="result"></margem-error
      ><!--Erro nos campos Boleta alterada-->
      <termo-moeda-error
        *ngIf="ticketTypesId === 8"
        [result]="result"
      ></termo-moeda-error>
      <transferencia-error
        *ngIf="ticketTypesId === 10"
        [result]="result"
      ></transferencia-error>
      <emprestimo-error
        *ngIf="ticketTypesId === 11"
        [result]="result"
      ></emprestimo-error>
      <cambio-error
        *ngIf="ticketTypesId === 12"
        [result]="result"
      ></cambio-error>
      <despesas-error
        *ngIf="ticketTypesId === 13"
        [result]="result"
      ></despesas-error>
      <passivos-error
        *ngIf="ticketTypesId === 15"
        [result]="result"
      ></passivos-error
      ><!-- Campos não estão sendo mostrados-->
    </div>
  </div>
</div>
